<template>
	<div class="ui-tabs-content" id="chinaAreaDetail">
		<div class="region-title"><h3>{{_ll('热门城市')}}</h3></div>
		<ul id="hot-city" class="ui-con hot-city">
			<li v-show="hotCities" v-for="city in hotCities" :key="city.code" @click="cityClick(city)"
				:class="{cur: curCity.code === city.code}">
				{{ city.name }}
			</li>
		</ul>
		<div class="region-title"><h3>{{_ll('省市区选择')}}</h3></div>
		<ul id="province-list" class="ui-con">
			<mt-picker :slots="myAddressSlots" :itemHeight="setFont(70)" value-key="name" @change="onMyAddressChange"></mt-picker>
		</ul>
	</div>
</template>

<script>
	import {Picker} from 'mint-ui'
	import {setFont} from '../../util/util'
	export default {
		name: 'ChinaArea',
		data() {
			return {
				myAddressSlots: [{
					flex: 1,
					defaultIndex: 1,
					values: this.provinceList,
					className: 'slot1',
					textAlign: 'center'
				}, {
					flex: 1,
					values: [],
					className: 'slot2',
					textAlign: 'center'
				}, {
					flex: 1,
					values: [],
					className: 'slot3',
					textAlign: 'center'
				}],
				mtPicker: {},
				myProvince: {},
				myCity: {},
				myCounty: {},
				curCity: {},
				curCounty: {},
				cityCount: 0,
				countyCount: 0
			}
		},
		props: {
			hotCities: {
				type: Array,
				defaultValue: []
			},
			provinceList: {
				type: Array,
				defaultValue: []
			},
			cityList: {
				type: Array,
				defaultValue: []
			},
			countyList: {
				type: Array,
				defaultValue: []
			},
			fromAddrObj: {
				selectCode: {
					type: String,
					defaultValue: ''
				},
				selectCityCode: {
					type: String,
					defaultValue: ''
				},
				selectProvinceCode: {
					type: String,
					defaultValue: ''
				}
			}
		},
		components: {
			'mt-picker': Picker
		},
		mounted: function () {
			// this.$nextTick(() => {
			//   this.myAddressSlots[0].defaultIndex = 0
			// })
		},
		activated: function () {
			if (this.myProvince.code && this.myCity.code && this.myCounty.code) {
				if (this.myCounty.code === 'COUNTY') {
					this.$emit('receiveData', this.myProvince, this.myCity, this.myCounty, true)
				} else {
					this.$emit('receiveData', this.myProvince, this.myCity, this.myCounty, false)
				}
			}
		},
		watch: {
			provinceList: function (newProvinceList) {
				if (newProvinceList && newProvinceList.length > 0) {
					if (this.fromAddrObj.selectProvinceCode
						&& this.fromAddrObj.selectProvinceCode !== 'PROVINCE') {
						let selectProvince = newProvinceList.find(data => data.code
							=== this.fromAddrObj.selectProvinceCode)
						if (selectProvince) {
							this.mtPicker.setSlotValue(0, selectProvince)
						}
					}
				}
			},
			cityList: function (newCityList) {
				if (newCityList && newCityList.length > 0) {
					this.mtPicker.setSlotValues(1, newCityList)
					this.mtPicker.setSlotValue(1, newCityList[0])
					if (this.cityCount === 0 && this.fromAddrObj.selectCityCode
						&& this.fromAddrObj.selectCityCode !== 'CITY') {
						this.curCity.code = this.fromAddrObj.selectCityCode
						this.cityCount = 1
					}
					if (this.curCity.code) {
						let tmpCity = newCityList.find(value => value.code === this.curCity.code)
						if (tmpCity) {
							this.mtPicker.setSlotValue(1, tmpCity)
						} else {
							this.curCity = {}
						}
					}
				}
			},
			countyList: function (newCountyList) {
				if (newCountyList !== undefined && newCountyList.length > 0) {
					this.mtPicker.setSlotValues(2, newCountyList)
					this.mtPicker.setSlotValue(2, newCountyList[0])
					if (this.countyCount === 0 && this.fromAddrObj.selectCode
						&& this.fromAddrObj.selectCode !== 'COUNTY') {
						this.curCounty.code = this.fromAddrObj.selectCode
						this.countyCount = 1
					}
					if (this.curCounty.code) {
						let tmpCounty = newCountyList.find(value => value.code === this.curCounty.code)
						if (tmpCounty) {
							this.mtPicker.setSlotValue(2, tmpCounty)
						} else {
							this.curCounty = {}
						}
					}
				}
			}
		},
		methods: {
			setFont,
			onMyAddressChange: function (picker, values) {
				let that = this
				that.myCounty = values[2]
				that.mtPicker = picker
				if (values[0] && that.myProvince.code !== values[0].code) {
					that.myProvince = values[0]
					that.$emit('changeData', values[0].code, values[0].level)
				}
				if (values[1] && that.myCity.code !== values[1].code) {
					that.curCity = that.myCity = values[1]
					that.$emit('changeData', values[1].code, values[1].level)
				}
				if (values[0] && values[1] && values[2]) {
					if (values[2].code === 'COUNTY') {
						that.$emit('receiveData', null, null, null, true)
					} else {
						that.$emit('receiveData', values[0], values[1], values[2], false)
					}
				}
			},
			cityClick: function (cityData) {
				let that = this
				that.curCity = cityData
				if (that.myProvince.code === cityData.parentCode) {
					that.mtPicker.setSlotValue(1, that.cityList.find(value => value.code === cityData.code))
				} else {
					let temProvince = that.provinceList.find(value => value.code === cityData.parentCode)
					if (temProvince) {
						that.mtPicker.setSlotValue(0, temProvince)
					}
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.region-title {
		height: 100px;
		line-height: 100px;
		padding-left: 20px;
		border-top: 1px solid $gray-dark;
	}
	.hot-city {
		overflow: hidden;
	}
	.hot-city li {
		float: left;
		height: 70px;
		line-height: 70px;
		width: 33.3333333%;
		text-align: center;
		color: $white;
	}
	.hot-city .cur {
		color: $white;
		background-color: $red;
	}
</style>



// WEBPACK FOOTER //
// src/components/region/china-area.vue